var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWidget(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    stroke: "currentColor",
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 6.6389C14.0025 7.59214 13.7798 8.53248 13.35 9.38334C12.8404 10.4029 12.057 11.2605 11.0876 11.86C10.1181 12.4596 9.00094 12.7773 7.8611 12.7778C6.90786 12.7803 5.96752 12.5576 5.11666 12.1278L1 13.5L2.37222 9.38334C1.94245 8.53248 1.71974 7.59214 1.72222 6.6389C1.72266 5.49906 2.04044 4.38185 2.63996 3.41241C3.23948 2.44298 4.09707 1.6596 5.11666 1.15002C5.96752 0.720248 6.90786 0.497535 7.8611 0.500021H8.22221C9.72757 0.58307 11.1494 1.21846 12.2155 2.28453C13.2815 3.3506 13.9169 4.77243 14 6.27779V6.6389Z",
    stroke: "inherit",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWidget);
export default __webpack_public_path__ + "static/media/widget.cfabfbd9.svg";
export { ForwardRef as ReactComponent };